import React from "react";
import { Link } from "react-router-dom";

// Nav-dropdown link to a category landing page (/learn/category/<slug>),
// served from Supabase.
const MenuLink = ({ title, category }) => (
  <Link
    to={`/learn/category/${category}`}
    style={{ cursor: "pointer", textDecoration: "none", color: "black" }}
  >
    {title}
  </Link>
);

export default MenuLink;
